import { Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

const CopyrightInfo = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://stylishop.com/">
        Stylishop
      </Link>{' '}
      {new Date().getFullYear()}
    </Typography>
  );
};

export default CopyrightInfo;
